import { circleStroke } from "../Brush/SVG/CircleStroke";
import { cloud } from "../Brush/SVG/Clouds";
import { rect } from "../Brush/SVG/rect";
import { spoke } from "../Brush/SVG/Spoke";
import { square } from "../Brush/SVG/Square";
import { squiggle } from "../Brush/SVG/Squiggle";

const circle = function (p: any, size: number) {
  p.circle(100, 100, size);
};

const star = function (ctx: any) {
  ctx.vertex(129.06, 67.73);
  ctx.vertex(192.97, 77.02);
  ctx.vertex(146.72, 122.09);
  ctx.vertex(157.64, 185.74);
  ctx.vertex(100.48, 155.69);
  ctx.vertex(43.33, 185.74);
  ctx.vertex(54.24, 122.09);
  ctx.vertex(8, 77.02);
  ctx.vertex(71.9, 67.73);
  ctx.vertex(100.48, 9.82);
};

const octagon = function (ctx: any): any {
  ctx.vertex(62.05, 6.81);
  ctx.vertex(7.81, 61.05);
  ctx.vertex(7.81, 137.76);
  ctx.vertex(62.05, 192);
  ctx.vertex(138.76, 192);
  ctx.vertex(193, 137.76);
  ctx.vertex(193, 61.05);
  ctx.vertex(138.76, 6.81);
};

const triangle = function (ctx: any) {
  ctx.vertex(10.7, 176.28);
  ctx.vertex(190, 176.28);
  ctx.vertex(100.35, 21);
};

const img = function (ctx: any, img: HTMLImageElement, opacity: number = 1) {
  try{
    ctx.globalAlpha = opacity;
    ctx.drawImage(img, 0, 0);
  } catch ( e ) {
    console.info(e)
  }
};

const ShapePicker = function (
  shape: number,
  p: any,
  size: number,
  ctx: any,
  image?: HTMLImageElement  | string ,
  opacity?: number
) {
  switch (shape) {
    case 0:
      return circle(p, size);
    case 1:
      return star(p);
    case 2:
      return spoke(ctx.drawingContext);
    case 3:
      return triangle(p);
    case 4:
      return square(ctx.drawingContext);
    case 5:
      return circleStroke(ctx.drawingContext);
    case 6:
      return cloud(ctx.drawingContext);
    case 7:
      return octagon(p);
    case 8:
      return rect(ctx.drawingContext);
    case 9:
      return squiggle(ctx.drawingContext);
    case 1000:
      if( typeof image == undefined ) {
        return undefined
      }
      let _img  = image;
      if( typeof _img == 'string' ) {
        _img = new Image();
        _img.src = image as string
      }
      return img(ctx.drawingContext, _img as HTMLImageElement, opacity);
    
      
  }
};

export default ShapePicker;
